import React from "react";
import Header from "../../components/common/Header";
import Button from "../../components/ui/Button";

const HeroSection = () => {
  return (
    <section className="w-full relative min-h-screen flex flex-col">
      {/* Sticky Header Wrapper */}
      <div className="sticky top-0 z-[100] w-full bg-transparent">
        <Header />
      </div>

      {/* Hero Background & Overlay */}
      <div
        className="absolute inset-0 w-full h-full bg-cover bg-center -z-10"
        style={{
          backgroundImage: "url('/images/img_image_10.png')",
        }}
      >
        {/* Blue Tint Overlay (As per image) */}
        <div className="absolute inset-0 bg-[#183076]/70 mix-blend-multiply"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#183076]/20 to-[#183076]/30"></div>
      </div>

      {/* Content Container */}
      <div className="flex-grow flex items-center justify-center px-4 sm:px-10">
        <div className="max-w-[1800px] mx-auto flex flex-col items-center text-center gap-6 md:gap-8">
          {/* Headline */}
          <h1
            className="text-[24px] md:text-[30px] lg:text-[40px] 2xl:text-[60px] font-bold text-white tracking-tight leading-tight"
            style={{ fontFamily: "Bricolage Grotesque" }}
          >
            Advancing Science and Healthcare <br className="hidden md:block" />
            Through Quality and Ethics
          </h1>

          {/* Description */}
          <p
            className="text-sm text-[14px] md:text-[18px] lg:text-[20px] 2xl:text-[24px] text-white/90 font-light max-w-[1600px] leading-relaxed"
            style={{ fontFamily: "Bricolage Grotesque" }}
          >
            ANVIYA Research Lab bridges the gap between groundbreaking research
            and accessible healthcare. We serve the global scientific community
            with ethically sourced, research-grade human biospecimens while
            providing local communities with accurate, reliable diagnostic
            testing. Our dual commitment ensures that every sample we
            handle—whether destined for a research laboratory or a patient
            report—meets the highest standards of quality, integrity, and
            ethical compliance. Founded on the principles of scientific rigor
            and patient care, ANVIYA has become a trusted partner for
            researchers advancing medical knowledge and individuals seeking
            dependable health insights.
          </p>

          {/* Action Button */}
          <div className="mt-4">
            <Button
              text="Explore More"
              variant="outline"
              className="border-white text-white rounded-full 2xl:px-10 2xl:py-3 hover:bg-white hover:text-[#183076] transition-all duration-300 backdrop-blur-sm text-[18px] 2xl:text-[24px]"
              style={{ fontFamily: "Bricolage Grotesque" }}
              to="/biospecimens-services"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
